import React from 'react';
import PreviewJobDetails from './partials/preview-job-details';
import PreviewJobDescription from './partials/preview-job-description';
import PreviewJobAppSettings from './partials/preview-job-app-settings';
import { useLocation, useNavigate } from 'react-router-dom';

const tabConst = {
  details: 'job-details',
  description: 'job-description',
  settings: 'application-settings'
};
const tabs = [
  { label: 'Job details', value: tabConst.details },
  { label: 'Job description', value: tabConst.description },
  { label: 'Application settings', value: tabConst.settings }
];
const CreateJobPreview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get('tab') || tabConst.details;

  const updateTab = (tab: string) => {
    searchParams.set('tab', tab);
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  return (
    <section>
      <div className='flex space-x-6 mb-10'>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => updateTab(tab.value)}
            className={`text-sm font-medium px-4 py-2 rounded-full duration-500 transition-all border
            ${
              activeTab === tab.value
                ? 'bg-white shadow text-black/90 border border-gray-1'
                : 'text-gray-5 hover:text-gray-700 border-transparent'
            }`}>
            {tab.label}
          </button>
        ))}
      </div>
      {activeTab === tabConst.settings && <PreviewJobAppSettings />}
      {activeTab === tabConst.description && <PreviewJobDescription />}
      {activeTab === tabConst.details && <PreviewJobDetails />}
    </section>
  );
};

export default CreateJobPreview;
